import { render } from "@/components/pages/individualWorkSupport/requirement051/Requirement051.html?vue&type=template&id=28c9251b&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement051/Requirement051.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement051/Requirement051.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement051/Requirement051.scss?vue&type=style&index=0&id=28c9251b&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c9251b"]])

export default __exports__